module.exports = __webpack_public_path__ + "assets/img/5a0089776ae07fecc195b30ebd519118.svg";